import React, { useState } from 'react';
import { Table, Tag } from 'react-unity';
import TAP from '../../models/entities/TAP';
import TAPDelegation from '../../models/entities/TAPDelegation';
import moment from 'moment';
import TemporaryAccessPasswordService from '../../services/TemporaryAccessPasswordService';
import TAPApprovals from './components/TAPApprovals';
import TAPRequests from './components/TAPRequests';
import TAPDelegated from './components/TAPDelegated';

interface TemporaryAccessPasswordTableRowProps {
    tap: any;
    tab: string;
    setTapModal: any;
    setEndModal: any;
    retreiveTaps: any;
    setTapass: any;
    temporaryAccessPasswordService: TemporaryAccessPasswordService;
}


const TemporaryAccessPasswordTableRow = ({tap, tab, setTapModal, setEndModal, retreiveTaps, setTapass, temporaryAccessPasswordService} : TemporaryAccessPasswordTableRowProps) => {

    const [loading, setLoading] = useState<boolean>(false);

    const handleCompleteTAP = async (tapId: number, approve: boolean) => {
        try {
            setLoading(true);
            setEndModal({ 
                visible: true,
                text: approve ? `Approving...` : 'Rejecting...',
                variant: 'default'
            });
            const response = await temporaryAccessPasswordService.completeTap(tapId, approve);
            setEndModal({ visible: false });
        }
        catch (err) {
            setEndModal({ 
                visible: true,
                text: `An error occurred when approving the TAP request. Please try again later.`,
                variant: 'error'
            });
        }
        retreiveTaps(true);
        setLoading(false);
    }

    const handleGetApprovedTap = async () => {
        try{
            setLoading(true);
            const response = await temporaryAccessPasswordService.getTapAfterApproved();
            setTapass(response.taPass);
            setTapModal(true);
        }
        catch (err){
            setEndModal({ 
                visible: true,
                text: `An error occurred when getting the TAP request. Please try again later.`,
                variant: 'error'
            });
        }
        retreiveTaps(true);
        setLoading(false);
    }

    const handleRejectTAP = async (tapId: number) => {
        try {
            setLoading(true);
            setEndModal({ 
                visible: true,
                text: 'Rejecting...',
                variant: 'default'
            });
            const response = await temporaryAccessPasswordService.disableDelegated(tapId);

            setEndModal({ 
                visible: true, 
                text: `TAP Delegated succesfully disabled.`,
                variant: 'success' 
            });
        }
        catch (err) {
            setEndModal({ 
                visible: true,
                text: `An error occurred when rejecting the TAP request. Please try again later.`,
                variant: 'error'
            });
        } finally {
            retreiveTaps(true);
            setLoading(false);
        }
    };
   
    return (
        <>
            
            <Table.Body.Row>
            {(() => {
                const isMyApprovals   = tab === 'My Approvals';
                const isMyRequests    = tab === 'My TAP Requests';
                const isDelegations   = tab === 'Delegations';
                const isOnBehalf      = tab === 'On Behalf Of';

                const formatDate = (date, withSeconds = true) =>
                date
                    ? moment
                        .utc(date)
                        .local()
                        .format(withSeconds ? 'DD/MM/YYYY, h:mm:ss a' : 'DD/MM/YYYY, h:mm a')
                    : '-';

                return (
                <>
                    {/* Date column */}
                    <Table.Body.Cell>
                    {isMyApprovals && formatDate(tap.createdTime)}
                    {isDelegations && formatDate(tap.createdDate, false)}
                    {!isMyApprovals && !isDelegations && formatDate(tap.startingTime)}
                    </Table.Body.Cell>

                    {/* Approver / Supervisor */}
                    <Table.Body.Cell className="em-u-text-align-center">
                    {!isDelegations && (tap.approver ? 'Yes' : 'No')}
                    {isDelegations && tap.supervisor?.displayName}
                    </Table.Body.Cell>

                    {/* Status */}
                    <Table.Body.Cell
                    className="em-u-text-align-center"
                    style={
                        isDelegations
                        ? { display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        : undefined
                    }
                    >
                    {!isDelegations && tap.approvalStatus}

                    {isDelegations && (
                        <Tag color={tap.delegatedStatus === 'Enabled' ? 'positive' : 'negative'}>
                        {tap.delegatedStatus}
                        </Tag>
                    )}
                    </Table.Body.Cell>

                    {/* Name column */}
                    <Table.Body.Cell className="em-u-text-align-center">
                    {isMyApprovals && tap.requestor?.displayName}
                    {isMyRequests && tap.approver?.displayName}
                    {isOnBehalf && tap.onBehalf?.displayName}
                    {isDelegations && tap.delegated?.displayName}
                    </Table.Body.Cell>

                    {/* Extra Delegations column */}
                    {isDelegations && (
                    <Table.Body.Cell className="em-u-text-align-center">
                        {tap.tapUser?.displayName}
                    </Table.Body.Cell>
                    )}

                    {/* Extra On Behalf Of column */}
                    {isOnBehalf && (
                    <Table.Body.Cell className="em-u-text-align-center">
                        {tap.delegated?.delegated?.displayName}
                    </Table.Body.Cell>
                    )}

                    {/* Actions */}
                    <Table.Body.Cell className="em-u-text-align-center" style={{ display: 'block' }}>
                    {isMyApprovals && (
                        <TAPApprovals
                        tap={tap}
                        handleCompleteTAP={handleCompleteTAP}
                        loading={loading}
                        />
                    )}

                    {isMyRequests && (
                        <TAPRequests
                        tap={tap}
                        handleGetApprovedTap={handleGetApprovedTap}
                        loading={loading}
                        />
                    )}

                    {isDelegations && (
                        <TAPDelegated
                        tap={tap}
                        handleRejectTAP={() => handleRejectTAP(tap.id)}
                        loading={loading}
                        />
                    )}
                    </Table.Body.Cell>
                </>
                );
            })()}
            </Table.Body.Row>
        </>
    );
}

export default TemporaryAccessPasswordTableRow;